<div class="header">
  <div class="left">
      <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
  </div>

  <div class="right">
      <span class="user-name" *ngIf="identity || token && false">
          {{ identity?.nombres + ' ' + identity?.apellidoP + ' ' + identity?.apellidoM }}
      </span>
      <button mat-button [matMenuTriggerFor]="menu" *ngIf="identity || token && false">
          <mat-icon class="icon" matBadgeColor="warn">person</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="openPerfil()">
              <mat-icon matBadgeColor="warn">person</mat-icon> Mi perfil
          </button>
          <button mat-menu-item (click)="logout()">
              <mat-icon>exit_to_app</mat-icon> Cerrar Sesi&oacute;n
          </button>
      </mat-menu>
      <button mat-icon-button matTooltip="Servicios" aria-label="Volver al inicio" (click)="back()">
          <mat-icon class="icon">home</mat-icon>
      </button>
  </div>
</div>



<div class="container" *ngIf="!buscando">

  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div mat-card-avatar class="example-header-image"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="title1b">Seguimiento de Certificados</div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subTitle">
          <p>Dirección de Obras Municipales</p>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content>

      <div class="row">

        <div class="rol-div">
          <h4 class="card-title">Número de Solicitud</h4>
          <mat-form-field class="mat-field-rol">
            <input matInput type="text" placeholder="Nº Solicitud" [formControl]="numSol">
            <button mat-button *ngIf="numSol.value" matSuffix mat-icon-button aria-label="Clear"
              (click)="numSol.setValue('')">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <!--
        <div class="rol-div">
          
          <h4 class="card-title">Fecha de ingreso</h4>
          <mat-form-field>
            <input matInput [matDatepicker]="picker" placeholder="Fecha" [formControl]="fecha_ingreso">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        -->

        <div class="btn-cont">
          <button color="primary" mat-raised-button (click)="get_certificado(numSol.value)"
            [disabled]="!numSol.valid && !fecha_ingreso.valid">Busqueda</button>
        </div>

      </div>

    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>
</div>

<div class="container" *ngIf="buscando">
  
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" align="right">
      <p>
      <button color="primary" mat-raised-button  (click)="volver()">Volver a buscar</button>
      </p>
    </div>

  </div>
  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div class="get-data-cont">
          
          <div class="title1b" align="center">Número de Solicitud : {{ certificado_info[0].fieldData._TRACER_ID }}</div>
        </div>
        <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <label class="card-title">Fecha de ingreso:</label>
          <label class="parag">
            {{ certificado_info[0].fieldData.zz_Ingreso_Fecha_Hora ? certificado_info[0].fieldData.zz_Ingreso_Fecha_Hora : 'No hay información ingresada' }} 
            
          </label>
        </div>
        <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <label class="card-title">Solicitante:</label>
          <label class="parag">
            {{ certificado_info[0].fieldData['Adm_Solicitantes::Sol_Nom_Sol_Emp'] ? certificado_info[0].fieldData['Adm_Solicitantes::Sol_Nom_Sol_Emp'] : 'No hay información ingresada' }}
          </label>
        </div>
        <div class="tab_info col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <mat-tab-group>
            <mat-tab
              label="{{ ele['rol'] }} "
              *ngFor="let ele of arreglo" style="font-weight: bold;">

              <div class="info-cont" *ngFor="let xyz of ele['data']">
                <div class="row" style="margin-top: 15px;">
                  <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <p>Nombre Certificado:</p>
                  </div>
                  <div class="info_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <p>
                      {{ xyz['nomCertificado'] ? xyz['nomCertificado'] : 'No hay información ingresada' }}
                    </p>
                  </div>
                  <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <p>Dirección:</p>
                  </div>
                  <div class="info_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <p>
                      {{ xyz['direccion'] ? xyz['direccion'] : 'No hay información ingresada' }}
                    </p>
                  </div>
                  
                  <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
                    <p>Estado:</p>
                  </div>
                  <div class="info_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
                    <p>
                      {{ xyz['estado'] ? xyz['estado'] : 'No hay información ingresada' }}
                    </p>
                  </div>
                </div>
                <hr>

              </div>

            </mat-tab>

          </mat-tab-group>
        </div>
      </div>

    </mat-card-header>
    <mat-card-content>
      <div class="row">

      </div>
    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>

</div>